import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import './Outline.css'

const Outline = () => {
  const [headings, setHeadings] = useState([])
  const [activeId, setActiveId] = useState('')
  const location = useLocation()

  useEffect(() => {
    // Extract headings from the current page
    const extractHeadings = () => {
      const contentArea = document.querySelector('.content-wrapper')
      if (!contentArea) return []

      const headingElements = contentArea.querySelectorAll('h2, h3')
      const headingsArray = Array.from(headingElements).map((heading) => ({
        id: heading.id,
        text: heading.textContent,
        level: parseInt(heading.tagName.charAt(1))
      }))

      return headingsArray
    }

    // Set headings after a short delay to ensure content is rendered
    setTimeout(() => {
      const newHeadings = extractHeadings()
      setHeadings(newHeadings)
    }, 100)

    // Intersection Observer to track active heading
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id)
          }
        })
      },
      { rootMargin: '-100px 0px -66%' }
    )

    const contentArea = document.querySelector('.content-wrapper')
    if (contentArea) {
      const headingElements = contentArea.querySelectorAll('h2, h3')
      headingElements.forEach((heading) => observer.observe(heading))
    }

    return () => observer.disconnect()
  }, [location])

  const scrollToHeading = (id) => {
    const element = document.getElementById(id)
    if (element) {
      const offset = 80
      const elementPosition = element.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.pageYOffset - offset

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })

      // Update URL with hash
      window.history.pushState(null, '', `#${id}`)
      setActiveId(id)
    }
  }

  if (headings.length === 0) {
    return null
  }

  return (
    <aside className="outline">
      <div className="outline-content">
        <h4 className="outline-title">On this page</h4>
        <nav className="outline-nav">
          {headings.map((heading) => (
            <button
              key={heading.id}
              className={`outline-link ${heading.level === 3 ? 'outline-link-nested' : ''} ${
                activeId === heading.id ? 'active' : ''
              }`}
              onClick={() => scrollToHeading(heading.id)}
            >
              {heading.text}
            </button>
          ))}
        </nav>
      </div>
    </aside>
  )
}

export default Outline
